import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';
import { createEntity, getEntity, reset, updateEntity } from './number-of-bedrooms.reducer';

export const NumberOfBedroomsUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const numberOfBedroomsEntity = useAppSelector(state => state.numberOfBedrooms.entity);
  const loading = useAppSelector(state => state.numberOfBedrooms.loading);
  const updating = useAppSelector(state => state.numberOfBedrooms.updating);
  const updateSuccess = useAppSelector(state => state.numberOfBedrooms.updateSuccess);
  const geographicLevelValues = Object.keys(GeographicLevel);

  const handleClose = () => {
    navigate(`/number-of-bedrooms${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAllHouseholds !== undefined && typeof values.totalAllHouseholds !== 'number') {
      values.totalAllHouseholds = Number(values.totalAllHouseholds);
    }
    if (values.noBedroom !== undefined && typeof values.noBedroom !== 'number') {
      values.noBedroom = Number(values.noBedroom);
    }
    if (values.oneBedroom !== undefined && typeof values.oneBedroom !== 'number') {
      values.oneBedroom = Number(values.oneBedroom);
    }
    if (values.twoBedrooms !== undefined && typeof values.twoBedrooms !== 'number') {
      values.twoBedrooms = Number(values.twoBedrooms);
    }
    if (values.threeBedrooms !== undefined && typeof values.threeBedrooms !== 'number') {
      values.threeBedrooms = Number(values.threeBedrooms);
    }
    if (values.fourBedrooms !== undefined && typeof values.fourBedrooms !== 'number') {
      values.fourBedrooms = Number(values.fourBedrooms);
    }
    if (values.fiveOrMoreBedrooms !== undefined && typeof values.fiveOrMoreBedrooms !== 'number') {
      values.fiveOrMoreBedrooms = Number(values.fiveOrMoreBedrooms);
    }

    const entity = {
      ...numberOfBedroomsEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          geographicLevel: 'EXTRA_WARD',
          ...numberOfBedroomsEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="apiLocationApp.numberOfBedrooms.home.createOrEditLabel" data-cy="NumberOfBedroomsCreateUpdateHeading">
            <Translate contentKey="apiLocationApp.numberOfBedrooms.home.createOrEditLabel">Create or edit a NumberOfBedrooms</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="number-of-bedrooms-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.geographicLevel')}
                id="number-of-bedrooms-geographicLevel"
                name="geographicLevel"
                data-cy="geographicLevel"
                type="select"
              >
                {geographicLevelValues.map(geographicLevel => (
                  <option value={geographicLevel} key={geographicLevel}>
                    {translate(`apiLocationApp.GeographicLevel.${geographicLevel}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.date')}
                id="number-of-bedrooms-date"
                name="date"
                data-cy="date"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.geography')}
                id="number-of-bedrooms-geography"
                name="geography"
                data-cy="geography"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.geographyCode')}
                id="number-of-bedrooms-geographyCode"
                name="geographyCode"
                data-cy="geographyCode"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.totalAllHouseholds')}
                id="number-of-bedrooms-totalAllHouseholds"
                name="totalAllHouseholds"
                data-cy="totalAllHouseholds"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.noBedroom')}
                id="number-of-bedrooms-noBedroom"
                name="noBedroom"
                data-cy="noBedroom"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.oneBedroom')}
                id="number-of-bedrooms-oneBedroom"
                name="oneBedroom"
                data-cy="oneBedroom"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.twoBedrooms')}
                id="number-of-bedrooms-twoBedrooms"
                name="twoBedrooms"
                data-cy="twoBedrooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.threeBedrooms')}
                id="number-of-bedrooms-threeBedrooms"
                name="threeBedrooms"
                data-cy="threeBedrooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.fourBedrooms')}
                id="number-of-bedrooms-fourBedrooms"
                name="fourBedrooms"
                data-cy="fourBedrooms"
                type="text"
              />
              <ValidatedField
                label={translate('apiLocationApp.numberOfBedrooms.fiveOrMoreBedrooms')}
                id="number-of-bedrooms-fiveOrMoreBedrooms"
                name="fiveOrMoreBedrooms"
                data-cy="fiveOrMoreBedrooms"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/number-of-bedrooms" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default NumberOfBedroomsUpdate;
